import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { YMMetricHelper, createMetric } from '@beef/metric';
import { selectHeaderDataForMetric } from "./selectors";
import { getMetricEcommerceData, getMetricSearchBannerData, getMetricSearchBlockData } from "./utillsSearchMetric";
import { EMetricAction, EMetricItemType } from "../types";
import { CARD_TYPE, RESULT_TEXT } from "../components/Search/utils/constants";
import { getAccountType, getClearText } from "../utils";
import { sendDataLayerAnalytics } from "./utils";
import { getIsSecondaryTransitionCookie, methodsDigi } from "../../../utils/analytics";
export var EMetricParamsKey;
(function (EMetricParamsKey) {
  EMetricParamsKey["region"] = "change_region";
  EMetricParamsKey["top"] = "top_ev_";
  EMetricParamsKey["menu"] = "menu";
  EMetricParamsKey["banners"] = "banners_ev_";
})(EMetricParamsKey || (EMetricParamsKey = {}));
export var HeaderMetric = /*#__PURE__*/function (_YMMetricHelper) {
  _inherits(HeaderMetric, _YMMetricHelper);
  var _super = _createSuper(HeaderMetric);
  function HeaderMetric() {
    var _this;
    _classCallCheck(this, HeaderMetric);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "setParamsPageInfo", function (params, key) {
      var _headerData$common, _headerData$common$au;
      if (typeof window === 'undefined') {
        return _defineProperty({}, key, _objectSpread({}, params));
      }
      var headerData = _this.getData();
      var accountType = getAccountType(headerData === null || headerData === void 0 ? void 0 : (_headerData$common = headerData.common) === null || _headerData$common === void 0 ? void 0 : (_headerData$common$au = _headerData$common.auth) === null || _headerData$common$au === void 0 ? void 0 : _headerData$common$au.user);
      return _defineProperty({}, key, _objectSpread({
        account_type: accountType,
        page_title: document.title,
        page_url: window.location.href,
        page_path: window.location.pathname
      }, params));
    });
    /**
     * Search
     */
    _defineProperty(_assertThisInitialized(_this), "YM_PARAMS_SEARCH_KEY", 'search_AnyQwery');
    _defineProperty(_assertThisInitialized(_this), "setParamsSearchInfo", function (params) {
      if (typeof window === 'undefined') return _defineProperty({}, _this.YM_PARAMS_SEARCH_KEY, _objectSpread({}, params));
      var headerData = _this.getData();
      var accountType = getAccountType(headerData === null || headerData === void 0 ? void 0 : headerData.common.auth.user);
      return _defineProperty({}, _this.YM_PARAMS_SEARCH_KEY, _objectSpread({
        account_type: accountType,
        page_title: document.title,
        page_url: window.location.href,
        page_path: window.location.pathname
      }, params));
    });
    return _this;
  }
  _createClass(HeaderMetric, [{
    key: "handleNavBannerEvent",
    value: /* Метрика навигации  */
    function handleNavBannerEvent(data) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'view';
      var parsedData = JSON.parse(data);
      sendDataLayerAnalytics({
        ecommerce: _defineProperty({}, action === 'click' ? 'promoClick' : 'promoView', {
          promotions: {
            id: "menu_".concat(parsedData.sectionText, "_").concat(parsedData.tabName),
            name: parsedData.bannerTitle,
            creative: parsedData.bannerUrl,
            position: 'menu_static',
            creative_slot: "".concat(parsedData.sectionText, "_").concat(parsedData.tabName)
          }
        })
      });
      this.sendParamsEvent(this.setParamsPageInfo({
        action: action,
        item_type: 'banner',
        banner_title: parsedData.bannerTitle,
        banner_description: parsedData.bannerDescription,
        banner_url: parsedData.bannerUrl,
        banner_type: 'static',
        object_type: 'menu',
        section_text: parsedData.sectionText,
        tab_name: parsedData.tabName
      }, EMetricParamsKey.banners));
    }
  }, {
    key: "handleNavBannerClick",
    value: function handleNavBannerClick(data) {
      this.handleNavBannerEvent(data, 'click');
    }
  }, {
    key: "handleCloseNavClick",
    value: function handleCloseNavClick() {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'icon',
        icon_name: 'close'
      }, EMetricParamsKey.menu));
    }
  }, {
    key: "handleNavLinkClick",
    value: function handleNavLinkClick(data) {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'link',
        link_text: data
      }, EMetricParamsKey.menu));
    }
  }, {
    key: "handleNavTabClick",
    value: function handleNavTabClick(data) {
      var parsedData = JSON.parse(data);
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'tab',
        tab_text: parsedData.tab,
        section_text: parsedData.section
      }, EMetricParamsKey.menu));
    }
  }, {
    key: "handleNavTabLinkClick",
    value: function handleNavTabLinkClick(data) {
      var parsedData = JSON.parse(data);
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'link',
        link_text: parsedData.link,
        tab_name: parsedData.tab,
        section_text: parsedData.section
      }, EMetricParamsKey.menu));
    }

    /* Метрика шапки  */
  }, {
    key: "handleTopBannerEvent",
    value: function handleTopBannerEvent(data) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'view';
      if (!window.ym) return;
      var parsedData = JSON.parse(data);
      sendDataLayerAnalytics({
        ecommerce: _defineProperty({}, action === 'click' ? 'promoClick' : 'promoView', {
          promotions: {
            id: parsedData.bannerId,
            name: parsedData.bannerTitle,
            creative: parsedData.bannerUrl,
            position: 'header_banner_static'
          }
        })
      });
      this.sendParamsEvent(this.setParamsPageInfo({
        action: action,
        item_type: 'banner',
        banner_title: parsedData.bannerTitle,
        banner_url: parsedData.bannerUrl,
        banner_type: 'static',
        object_type: 'header'
      }, EMetricParamsKey.banners));
    }
  }, {
    key: "handleTopBannerClick",
    value: function handleTopBannerClick(data) {
      this.handleTopBannerEvent(data, 'click');
    }
  }, {
    key: "handleTopBannerClose",
    value: function handleTopBannerClose(data) {
      var parsedData = JSON.parse(data);
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'icon',
        icon_type: 'close',
        banner_title: parsedData.bannerTitle,
        banner_url: parsedData.bannerUrl,
        banner_type: 'static',
        object_type: 'header'
      }, EMetricParamsKey.banners));
    }
  }, {
    key: "handleTopButtonClick",
    value: function handleTopButtonClick(data) {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'button',
        button_text: data
      }, EMetricParamsKey.top));
    }
  }, {
    key: "handleTopIconClick",
    value: function handleTopIconClick(data) {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'icon',
        icon_name: data
      }, EMetricParamsKey.top));
    }

    /* Метрика регионов  */
  }, {
    key: "handleChangeRegionClick",
    value: function handleChangeRegionClick(data) {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'button',
        button_text: data
      }, EMetricParamsKey.region));
    }
  }, {
    key: "handleSearchRegionClick",
    value: function handleSearchRegionClick() {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'field',
        field_name: 'поиск региона'
      }, EMetricParamsKey.region));
    }
  }, {
    key: "handleClearSearchRegionClick",
    value: function handleClearSearchRegionClick() {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'icon',
        icon_name: 'close',
        field_name: 'поиск региона'
      }, EMetricParamsKey.region));
    }
  }, {
    key: "handleChosenRegionClick",
    value: function handleChosenRegionClick(data) {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'element',
        element_text: data
      }, EMetricParamsKey.region));
    }
  }, {
    key: "handleCloseRegionModalClick",
    value: function handleCloseRegionModalClick() {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'icon',
        icon_name: 'close',
        popup_title: 'выберите ваше местоположение'
      }, EMetricParamsKey.region));
    }
  }, {
    key: "handleViewModalSearch",
    value: function handleViewModalSearch() {
      this.sendParamsEvent(this.setParamsSearchInfo({
        action: EMetricAction.view,
        item_type: EMetricItemType.popup,
        popup_title: 'search'
      }));
    }
  }, {
    key: "handleClickSearchInput",
    value: function handleClickSearchInput() {
      this.sendParamsEvent(this.setParamsSearchInfo({
        action: EMetricAction.click,
        item_type: EMetricItemType.field,
        field_name: 'AnyQwery'
      }));
    }
  }, {
    key: "handleChangeSearch",
    value: function handleChangeSearch() {
      var _this$getData;
      this.sendParamsEvent(this.setParamsSearchInfo({
        action: EMetricAction.fill_in,
        item_type: EMetricItemType.field,
        field_name: 'AnyQwery',
        field_text: (_this$getData = this.getData()) === null || _this$getData === void 0 ? void 0 : _this$getData.search.query
      }));
      this.sendReachGoalEvent('InternalSearchl', {
        search_status_dm_: true
      });
    }
  }, {
    key: "handleViewSearchBlock",
    value: function handleViewSearchBlock(data) {
      var metric = getMetricSearchBlockData({
        data: data,
        action: EMetricAction.view
      });
      this.sendParamsEvent(this.setParamsSearchInfo(metric));
    }
  }, {
    key: "handleViewSearchElementBlock",
    value: function handleViewSearchElementBlock(data) {
      var _this$getData2;
      var query = (_this$getData2 = this.getData()) === null || _this$getData2 === void 0 ? void 0 : _this$getData2.search.query;
      var metric = getMetricSearchBlockData({
        data: data,
        action: EMetricAction.view,
        isEvery: true,
        query: query
      });
      this.sendParamsEvent(this.setParamsSearchInfo(metric));
    }
  }, {
    key: "handleClickSearchChips",
    value: function handleClickSearchChips(data) {
      var _this$getData3;
      var query = (_this$getData3 = this.getData()) === null || _this$getData3 === void 0 ? void 0 : _this$getData3.search.query;
      var metric = getMetricSearchBlockData({
        data: data,
        action: EMetricAction.click,
        isEvery: true,
        query: query
      });
      this.sendParamsEvent(this.setParamsSearchInfo(metric));
    }
  }, {
    key: "handleClickSearchElementBlock",
    value: function handleClickSearchElementBlock(data) {
      var _this$getData4;
      var query = (_this$getData4 = this.getData()) === null || _this$getData4 === void 0 ? void 0 : _this$getData4.search.query;
      var metric = getMetricSearchBlockData({
        data: data,
        action: EMetricAction.click,
        isEvery: true,
        query: query
      });

      // проставляем флаг вторичного перехода для фильтрации аналитики
      var isSecondaryTransition = getIsSecondaryTransitionCookie();
      metric.secondary_transition = isSecondaryTransition;
      this.sendParamsEvent(this.setParamsSearchInfo(metric));
    }
  }, {
    key: "handleClickSearchElementDigi",
    value: function handleClickSearchElementDigi(data) {
      var _this$getData5;
      var cell = JSON.parse(data);
      var search = (_this$getData5 = this.getData()) === null || _this$getData5 === void 0 ? void 0 : _this$getData5.search;
      var query = (search === null || search === void 0 ? void 0 : search.query) || '';
      methodsDigi.sendProductsClickEvent({
        query: query,
        correction: search === null || search === void 0 ? void 0 : search.correction,
        item: cell.title,
        productId: cell.id
      });
    }
  }, {
    key: "handleClickSearchButtonAllResult",
    value: function handleClickSearchButtonAllResult() {
      var _this$getData6;
      this.sendParamsEvent(this.setParamsSearchInfo({
        action: EMetricAction.click,
        item_type: EMetricItemType.button,
        button_text: RESULT_TEXT,
        field_text: (_this$getData6 = this.getData()) === null || _this$getData6 === void 0 ? void 0 : _this$getData6.search.query
      }));
    }
  }, {
    key: "handleViewSearchEmptyStatus",
    value: function handleViewSearchEmptyStatus() {
      var _this$getData7, _this$getData8;
      this.sendParamsEvent(this.setParamsSearchInfo({
        action: EMetricAction.view,
        item_type: EMetricItemType.notification,
        notification_text: getClearText((_this$getData7 = this.getData()) === null || _this$getData7 === void 0 ? void 0 : _this$getData7.common.search.defaults.contentEmptyText),
        field_text: (_this$getData8 = this.getData()) === null || _this$getData8 === void 0 ? void 0 : _this$getData8.search.query
      }));
    }
  }, {
    key: "handleViewSearchBanners",
    value: function handleViewSearchBanners(data) {
      var metric = getMetricSearchBannerData(data, EMetricAction.view);
      this.sendParamsEvent(this.setParamsSearchInfo(metric));
    }
  }, {
    key: "handleClickSearchBanners",
    value: function handleClickSearchBanners(data) {
      var metric = getMetricSearchBannerData(data, EMetricAction.click);
      this.sendParamsEvent(this.setParamsSearchInfo(metric));
    }
  }, {
    key: "handleEcommerceEvent",
    value: function handleEcommerceEvent(data) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'view';
      if (!window.ym) return;
      var metric = getMetricEcommerceData(data);
      if (metric[0].category === CARD_TYPE.tariff || metric[0].category === CARD_TYPE.product) {
        sendDataLayerAnalytics({
          ecommerce: _defineProperty({
            currencyCode: 'RUB'
          }, action === 'view' ? 'impressions' : action, action === 'view' ? metric : {
            products: metric
          })
        });
      }
    }
  }, {
    key: "handleClickEcommerce",
    value: function handleClickEcommerce(data) {
      this.handleEcommerceEvent(data, 'click');
    }
  }]);
  return HeaderMetric;
}(YMMetricHelper);
export var headerMetric = new HeaderMetric({
  counterId: 26001372,
  isEcommerce: false,
  debug: false,
  selector: selectHeaderDataForMetric
});
var _createMetric = createMetric({
    headerMetric: headerMetric
  }, 'debug'),
  Metric = _createMetric.Metric,
  withMetricContainer = _createMetric.withMetricContainer,
  decorateHandler = _createMetric.decorateHandler,
  withMetric = _createMetric.withMetric;
export { Metric, withMetricContainer, decorateHandler, withMetric };